( ( { hooks: { addAction: addActionBe } }, { hooks: { addAction: addActionFe } } ) => { // eslint-disable-line
} )( wp, feWp ); // eslint-disable-line 

( ( { hooks: { addFilter: addFilterBe } } ) => // NOSONAR
{  
  addFilterBe(
    'b3rg_primary_term_enabled_taxonomies',
    'b3rg/primary_tag',
    // eslint-disable-next-line no-unused-vars
    ( defaultValue ) => {
      const dropDownHideTaxonomies = {
        blog: ['blog-category'],
        resource: ['resource-category'],
        post: ['category']
      };
      return dropDownHideTaxonomies;
    }
  );
// eslint-disable-next-line
} )( wp, feWp ); // NOSONAR
